import { string } from '@eti/utils';
import { MAX_CHILD_AGE, MIN_CHILD_AGE } from '../../../../widgets/search-form/constants/passengers';
import { changeValueWithOperand } from '../../../../widgets/search-form/utils/passengers';
import OptionLabel from '../../components/edit-passengers/OptionLabel';
import { agesOptionsStyles } from './passengersStyles';
import { generateSelection, isValidSelection } from './Passengers';

export const clampChildAge = (age) => {
  if (age < MIN_CHILD_AGE) {
    return MAX_CHILD_AGE;
  }
  if (age > MAX_CHILD_AGE) {
    return MIN_CHILD_AGE;
  }
  return age;
};

export const onChildrenCounterClick =
  (operand, adults, children, infants, childrenAges, infantsAges, onChange) => () => {
    const newChildren = changeValueWithOperand(children, operand);
    if (isValidSelection(adults, newChildren, infants)) {
      onChange(generateSelection(adults, newChildren, infants, childrenAges, infantsAges));
    }
  };

export const onChildAgeCounterClick =
  (operand, childIndex, adults, children, infants, childrenAges, infantsAges, onChange) => () => {
    const newChildrenAges = childrenAges.map((age, i) =>
      i === childIndex ? clampChildAge(changeValueWithOperand(age, operand)) : age,
    );
    onChange(generateSelection(adults, children, infants, newChildrenAges, infantsAges));
  };

export const generateChildrenAgesOptions = (
  numberOfAdults,
  numberOfChildren,
  numberOfInfants,
  childAgeInfo,
  childrenAges,
  infantsAges,
  onChange,
  childAgeLabel,
) => {
  if (numberOfChildren > 0) {
    const childrenAgesOptions = Array.from({ length: numberOfChildren }, (_, i) => ({
      dataTestId: `child-${i}-age-option`,
      label: (
        <OptionLabel
          id={`child-${i}-age`}
          onMinusClick={onChildAgeCounterClick(
            'subtract',
            i,
            numberOfAdults,
            numberOfChildren,
            numberOfInfants,
            childrenAges,
            infantsAges,
            onChange,
          )}
          onPlusClick={onChildAgeCounterClick(
            'add',
            i,
            numberOfAdults,
            numberOfChildren,
            numberOfInfants,
            childrenAges,
            infantsAges,
            onChange,
          )}
          title={string.insertArgument(childAgeLabel, i + 1)}
          value={childrenAges[i]}
        />
      ),
      className: agesOptionsStyles(i),
    }));

    return [
      {
        label: `${childAgeInfo}`,
        options: childrenAgesOptions,
      },
    ];
  }

  return [];
};
